export function isNullableValue<T>(value: T): value is T {
  return value === null || value === undefined;
}
